export default __webpack_public_path__ + "static/media/location-pin.3132df82.svg";